import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
	legend: {
		width: 150
	},
	legendItem: {
		margin: 2,
		display:'flex',
		alignItems:'start',
		justifyContent:'left',	
	},
	svgIcon: {
		marginTop: 3,
	},
	chartContainer: {
		width: 899,
	},
	chart: {
		marginBottom: 10,
		//paddingLeft: 145
	},
	table: {
		'& .MuiTableCell-root': {
			fontSize: 10,
			padding: 0,
			borderColor: 'black',
			border: '1px solid'
		},
		'& .MuiTableCell-head': {
			backgroundColor: '#BEE1FC',
			'&:nth-of-type(odd)': {
				backgroundColor: '#DDF0FF',
			},
			'&:nth-of-type(1)': {
				backgroundColor: 'white',
				border: 'none',
			},
		},
		paddingRight: 19
	},
	tableGeneralBody: {
		'& .MuiTableCell-root': {
			backgroundColor: 'rgba(255, 0, 0, 0.4);',
			'&:nth-of-type(odd)': {
				backgroundColor: 'rgba(255, 0, 0, 0.3);',
			},
			'&:nth-of-type(1)': {
				width: 200,
			},
		},
	},
	tableContraceptivesBody: {
		'& .MuiTableRow-root:first-child': {
			backgroundColor: 'rgb(200, 100, 0, 0.5)',
			'& .MuiTableCell-root': {
				fontWeight: 'bold'
			}
		},
		'& .MuiTableCell-root': {
			backgroundColor: 'rgba(234, 124, 0, 0.4);',
			'&:nth-of-type(odd)': {
				backgroundColor: 'rgba(234, 124, 0, 0.3);',
			},
			'&:nth-of-type(1)': {
				width: 200,
			},
		},
	},
	tableFertilityBody: {
		'& .MuiTableRow-root:first-child': {
			backgroundColor: 'rgb(106, 148, 218)',
			'& .MuiTableCell-root': {
				fontWeight: 'bold'
			}
		},
		'& .MuiTableCell-root': {
			backgroundColor: 'rgba(106, 148, 218, 0.5);',
			'&:nth-of-type(odd)': {
				backgroundColor: 'rgba(106, 148, 218, 0.3);',
			},
			'&:nth-of-type(1)': {
				width: 200,
			},
		},
	},
	tableCancerBody: {
		'& .MuiTableRow-root:first-child': {
			backgroundColor: 'rgb(0, 179, 179)',
			'& .MuiTableCell-root': {
				fontWeight: 'bold'
			}
		},
		'& .MuiTableCell-root': {
			backgroundColor: 'rgba(0, 179, 179, 0.5);',
			'&:nth-of-type(odd)': {
				backgroundColor: 'rgba(0, 179, 179, 0.3);',
			},
			'&:nth-of-type(1)': {
				width: 200,
			},
		},
	},
	tableCancerTreatment: {
		backgroundColor: 'rgb(0, 179, 179)',
		'& .MuiTableCell-root': {
			fontWeight: 'bold'
		}
	},
}));

export default useStyles;
